module.exports = __webpack_public_path__ + "img/x-circle.51984023.svg";